import { render, staticRenderFns } from "./DocumentsLibrary.vue?vue&type=template&id=aea77234&"
import script from "./DocumentsLibrary.vue?vue&type=script&lang=ts&"
export * from "./DocumentsLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports